import { useParams } from 'react-router-dom';
import { iframeOnLoadHelper } from '../../../helper/iframeOnLoadHelper';
import { ELDA_URL } from '../../../variables';
import Terms from '../../components/common/Terms';

const ApiDocPage = () => {

    const params = useParams();

    let src = '';

    let doc = params ? params["*"] : undefined;

    if(!doc || doc === "undefined"){
        src = `${ELDA_URL}/doc`
    } else {
        src = `${ELDA_URL}/doc/${doc}`
    }

    if(src.endsWith("/")){
        src = src.slice(0, -1);
    }

    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <iframe
                title="ApiDocPage"
                src={src}
                style={{ width: '100%', height: 'calc(100vh - 95px)' }}
                onLoad={iframeOnLoadHelper}
            />
            <Terms />
        </div>
    );
};

export default ApiDocPage;
